// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { AssetType } from '@interfaces/document.interfaces';
import { s3Asset } from '@interfaces/s3asset.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class s3AssetService {
    private _assets: BehaviorSubject<s3Asset[]> = new BehaviorSubject([]);
    assetTypeId: AssetType;

    constructor(private readonly apiService: ApiService) {}

    get headerAssets$(): Observable<s3Asset[]> {
        return this._assets.asObservable();
    }

    getAssets$(assetTypeId: number): Observable<s3Asset[]> {
        return this.apiService.getV2$<s3Asset[]>(`api/file/s3Asset/list/${assetTypeId}`).pipe(
            map((response) => {
                if (response?.data) {
                    this._assets.next(response.data);
                    return response.data;
                }

                return [];
            })
        );
    }
}
